import {
  useEffect, useState,
} from 'react';

const defaultCountdown = 10000; // in mileseconds

export default (cb, countdown = defaultCountdown) => {
  const [timeLeft, setTimeLeft] = useState(countdown);

  useEffect(() => {
    if(timeLeft === 0) {
      setTimeLeft(null);
      cb();
    }

    // exit early when we reach 0
    if (!timeLeft) {
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1000);
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  return [timeLeft, setTimeLeft];
};
